function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 9.5h7m-7-2h7m-7-2h7m-7 6h4",
  strokeLinecap: "round",
  stroke: "#FFF",
  strokeLinejoin: "round"
}));
function SvgShiftNoteWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}
export default SvgShiftNoteWhite;